import axios, { AxiosRequestConfig } from 'axios'

export const ApiService = {
  init (baseUrl: string) {
    axios.defaults.baseURL = baseUrl
    axios.defaults.headers['Content-Type'] = 'application/vnd.api+json; charset=utf-8'
  },
  get (resource: string, config?: AxiosRequestConfig) {
    return axios.get(resource, config)
  },

  post<T extends {}> (resource: string, data: T) {
    return axios.post(resource, data)
  },

  put<T extends {}> (resource: string, data: T) {
    return axios.put(resource, data)
  }
}
